import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/features/analytics/gtm-event-trackers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDescription"] */ "/app/src/components/features/product-page/product-description.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/features/product-page/product-page-cart-edit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/features/shop/product-preview/product-preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/product/product-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/components/shared/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared/ui/image-with-fallback.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared/ui/tooltip.tsx");
